<template>
    <div class="summary">
        <div class="boxes">
            <div class="box">
                <div class="icon">
                    <span class="material-icons"> outgoing_mail </span>
                </div>
                <div class="content">
                    <div class="value">{{ model.messages.length }}</div>
                    <div class="title">{{ $t("wp.messages") }}</div>
                </div>
            </div>
            <div class="box">
                <div class="icon">
                    <span class="material-icons"> people </span>
                </div>
                <div class="content">
                    <div class="value">{{ model.all ? contacts.length : model.customNumbers.length }}</div>
                    <div class="title">{{ $t("wp.recipients") }}</div>
                </div>
            </div>
            <div class="box">
                <div class="icon">
                    <span class="material-icons"> schedule </span>
                </div>
                <div class="content">
                    <div class="value">{{ getSendingTime() }}</div>
                    <div class="title">{{ $t("wp.broadcast.sendingTime") }}</div>
                </div>
            </div>
            <div class="box">
                <div class="icon">
                    <span class="material-icons"> watch_later </span>
                </div>
                <div class="content">
                    <div class="value">{{ getEstimatedTookTime() }}</div>
                    <div class="title">{{ $t("wp.estimatedTime") }}</div>
                </div>
            </div>
            <div class="box" v-if="showBroadcastMmliteChoice">
                <div class="icon">
                    <span class="material-icons">alt_route</span>
                </div>
                <div class="content">
                    <div class="value value-text">{{ broadcastSendPathSummary }}</div>
                    <div class="title">{{ $t("whatsapp_business_api.mmLiteBroadcastSectionTitle") }}</div>
                </div>
            </div>
        </div>
        <!--        <a-divider />-->
        <!--        <div class="w-100 d-flex justify-content-end d-none">-->
        <!--            <md-button class="md-raised md-primary" :disabled="loading" @click="submit">-->
        <!--                <div class="d-flex align-items-center justify-content-center px-3">-->
        <!--                    <span class="material-icons mr-3"> send </span>-->
        <!--                    {{ loading ? "Sending" : "Send" }}-->
        <!--                </div>-->
        <!--            </md-button>-->
        <!--        </div>-->
    </div>
</template>

<script>
import moment from "moment";
import CONFIG from "../../../../../../config/config";
import { mapState } from "vuex";

export default {
    name: "Summary",
    props: {
        model: {
            type: Object,
            default: () => ({}),
        },
        contacts: {
            type: Array,
            default: () => [],
        },
        submit: {
            type: Function,
            default: () => {},
        },
        loading: {
            type: Boolean,
            default: false,
        },
        channel: {
            type: Object,
            default: () => {},
        },
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
        }),
        showBroadcastMmliteChoice() {
            var ch = this.channel;
            if (!ch || ch.type !== "whatsapp-business-api-supsis") return false;
            const onboarded = ch.payload && ch.payload.marketingMessagesOnboardingStatus === "ONBOARDED";
            if (!onboarded) return false;
            const t = this.model.selectedTemplate;
            if (!t || !t.category) return false;
            return String(t.category).toUpperCase() === "MARKETING";
        },
        broadcastSendPathSummary() {
            if (this.model.sendTemplateViaMmlite === false) {
                return this.$t("whatsapp_business_api.mmLiteBroadcastSummaryStandard");
            }
            return this.$t("whatsapp_business_api.mmLiteBroadcastSummaryRecommended");
        },
    },
    methods: {
        getSendingTime() {
            if (this.model.sendNow) {
                return this.$t("wp.now");
            }
            return moment(this.model.sendFutureAt).format("MMMM Do YYYY, h:mm:ss a");
        },
        getEstimatedPrice() {
            const gupshupPrice = CONFIG.WHATSAPP.PRICE.marketingBasePrice * CONFIG.WHATSAPP.PRICE.dollarDefaultPrice;
            const supsisFee = 0.001 * 1.5 * CONFIG.WHATSAPP.PRICE.dollarDefaultPrice;
            let pricePerMessage;
            if (this.channel.type == "whatsapp-business-api") {
                pricePerMessage = gupshupPrice + (gupshupPrice * this.site.gupshupCommission) / 100;
            } else if (this.channel.type === "whatsapp-business-api-supsis") {
                pricePerMessage = supsisFee;
            } else {
                pricePerMessage = this.site.whatsappPerMessagePrice;
            }

            const messageCount = this.model.messages.length;
            const recipientCount = this.model.all ? this.contacts.length : this.model.customNumbers.length;
            return (pricePerMessage * messageCount * recipientCount).toFixed(2);
        },
        getEstimatedTookTime() {
            return this.$t("wp.tenMinute");
        },
    },
};
</script>

<style scoped lang="scss">
.boxes {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .box {
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        border: 1px solid #e8e8e8;
        padding: 20px;
        cursor: pointer;

        &:hover {
            background-color: #f5f5f5;
        }

        .icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            background: #f5f5f5;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 20px;

            span {
                font-size: 20px;
            }
        }

        .content {
            .value {
                font-size: 30px;
                font-weight: 600;
            }

            .value.value-text {
                font-size: 15px;
                line-height: 1.35;
                font-weight: 600;
            }

            .title {
                font-size: 14px;
                color: #1890ff;
                margin-top: 5px;
            }
        }
    }

    @media (min-width: 768px) {
        .box {
            width: 48%;
        }
    }
    @media (min-width: 992px) {
        .box {
            //  width: 23%;
        }
    }
}
</style>
